import React from 'react';

import InherentIcon from './logo/icon-inherent.png';

const LogoIcon = () => {
  return <img src={InherentIcon} alt="Logo inherent" style={{width: 'auto', height: 30}} />;
};

export default LogoIcon;
